/* sk-ratgeber-hub.js — Ratgeber-Übersicht (sections/sk-ratgeber-hub.liquid)
   Themen-Filter in der Suche, „Alle Themen anzeigen“, sanftes Scrollen der Bereichs-Chips.
   Wird von layout/theme.liquid auf der Ratgeber-Seite mit defer geladen. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss');
  }

  function init(root) {
    if (root.dataset.skRhReady) return;
    root.dataset.skRhReady = '1';
    root.classList.add('sk-rh--js');

    // „Alle X Themen anzeigen“
    root.querySelectorAll('[data-sk-rh-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.closest('[data-sk-rh-cat]');
        var open = cat.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = btn.querySelector('[data-sk-rh-more-label]');
        if (label) label.textContent = open ? btn.dataset.less : btn.dataset.more;
        if (!open) cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Bereichs-Chips: sanft scrollen und Bereich aufklappen
    root.querySelectorAll('[data-sk-rh-chip]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        var id = (chip.getAttribute('href') || '').slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    // Suche: Themen live filtern, Enter sucht in allen Artikeln (Shopify-Suche)
    var input = root.querySelector('[data-sk-rh-search]');
    if (!input) return;
    var clearBtn = root.querySelector('[data-sk-rh-clear]');
    var empty = root.querySelector('[data-sk-rh-empty]');
    var searchAll = root.querySelector('[data-sk-rh-searchall]');
    var status = root.querySelector('[data-sk-rh-status]');
    var topics = root.querySelector('.sk-rh__topics');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sk-rh-card]'));
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-sk-rh-cat]'));
    cards.forEach(function (c) { c._q = norm(c.dataset.q); });
    var searchBase = searchAll ? searchAll.getAttribute('href') : '';
    var scrolled = false;
    var timer;

    function apply() {
      var raw = input.value.trim();
      var terms = norm(raw).split(/\s+/).filter(Boolean);
      var active = terms.length > 0;
      root.classList.toggle('is-searching', active);
      if (clearBtn) clearBtn.hidden = !active;
      var shown = 0;
      cards.forEach(function (c) {
        var hit = !active || terms.every(function (t) { return c._q.indexOf(t) !== -1; });
        c.classList.toggle('is-hidden', !hit);
        if (hit) shown++;
      });
      cats.forEach(function (cat) {
        cat.hidden = active && !cat.querySelector('[data-sk-rh-card]:not(.is-hidden)');
      });
      if (empty) empty.hidden = !active || shown > 0;
      if (searchAll) searchAll.setAttribute('href', searchBase + '&q=' + encodeURIComponent(raw));
      if (status) status.textContent = active ? (status.dataset.tpl || '%count%').replace('%count%', shown) : '';
      if (active && !scrolled && topics && window.innerWidth <= 768) {
        scrolled = true;
        var y = input.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      if (!active) scrolled = false;
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(apply, 120); });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; apply(); } });
    if (input.value) apply();
  }

  function run() { document.querySelectorAll('[data-sk-rh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
